<div appFocusNearest *isLoading="isSachverhaltLoading$ | async">
  <app-dynamic-sachverhalte-form
    [header]="header"
    [fields]="fields"
    [values]="values"
    [emptyFields]="emptyFields"
    [serverValidationErrors]="serverValidationErrors$ | async"
  >
  </app-dynamic-sachverhalte-form>

  <div class="uba-button-group">
    <button 
      class="btn btn-default" 
      (click)="close()">
      {{ 'action.cancel' | translate }}
    </button>
    <button
      class="btn btn-default"
      [disabled]="!isFormValid"
      (click)="neuenSachverhaltErstellen(true)">
      <i class="fas fa-sm fa-save" aria-hidden="true"></i>
      {{ 'action.createAndClose' | translate }}
    </button>    
    <button
      class="btn btn-primary"
      [disabled]="!isFormValid"
      (click)="neuenSachverhaltErstellen(false)">
      <i class="fas fa-sm fa-save" aria-hidden="true"></i>
      {{ 'action.createAndReopen' | translate }}
    </button>
  </div>
</div>
